import React, { useState } from 'react';
import { Modal, Button } from '@/components';
import style from './index.module.css';
import { IconRcHiAccountModalClose, IconRcAccountSuccess } from '@/assets/account';

import cx from 'clsx';

const { CommonModal } = Modal;

type AccountModalProps = {
  turnOff(): void;
  steps: any[];
  isLoading: boolean;
  successText?: string;
  buttonText?: string;
  headerTitle?: string;
  isButtonDisabled?: boolean;
  hideSteps?: boolean;
  headerTips?: string;
  containerClass?: string;
  buttonColor?: 'green' | 'default';
  hideButton?: boolean;
};

const _AccountModal = ({
  turnOff,
  steps,
  isLoading,
  successText,
  buttonText,
  isButtonDisabled,
  headerTitle,
  // hideSteps,
  containerClass,
  headerTips,
  hideButton,
  buttonColor = 'default',
}: AccountModalProps) => {
  const [activeStepIndex, seActiveStepIndex] = useState(-1);

  const onClickButton = () => {
    if (activeStepIndex > steps.length - 2) {
      turnOff();
      window.location.reload();
      return;
    }
    steps[activeStepIndex + 1]?.handler(() => {
      seActiveStepIndex(activeStepIndex + 1);
    });
  };

  return (
    <CommonModal onRequestClose={turnOff} containerClassName={style.container} size="medium">
      {successText ? (
        <div className={style.successPage}>
          <IconRcAccountSuccess className={style.successIcon} />
          <div className={style.successTitle}>{successText}</div>
        </div>
      ) : (
        <div className={style.modalContainer}>
          <div className={style.modalHeader}>
            <span className={style.title}>{headerTitle}</span>
            <IconRcHiAccountModalClose className={style.closeIcon} onClick={turnOff} />
          </div>

          <div className={style.modalBody}>
            {headerTips ? <div className={style.headerTips}>{headerTips}</div> : null}
            <div className={style.mainContainer}>{steps[activeStepIndex + 1]?.content}</div>
          </div>
        </div>
      )}

      <div className={style.modalFooter}>
        <div className={cx(style.textAboveButton)}>{steps[activeStepIndex + 1]?.bottomText}</div>
        {hideButton ? null : (
          <Button
            type="primary"
            className={cx(
              style.modalButton,
              buttonColor === 'green' ? style.modalGreenColor : null,
            )}
            loading={isLoading}
            showLoadingChildren
            disabled={isButtonDisabled}
            onClick={onClickButton}>
            {buttonText}
          </Button>
        )}
      </div>
    </CommonModal>
  );
};

export const AccountModal = React.memo(_AccountModal);
